import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {FolderDirectoryService} from "@services/folder-directory/folder-directory.service";
import {combineLatest, Observable} from "rxjs";
import {IFolderPath} from "@interfaces/folder";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {map} from "rxjs/operators";

type FoldersRouteData = { route: IFolderPath, activatedPath: boolean }

@UntilDestroy()
@Component({
    selector: 'app-directory-breadcrumbs',
    templateUrl: './directory-breadcrumbs.component.html',
    styleUrls: ['./directory-breadcrumbs.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DirectoryBreadcrumbsComponent implements OnInit {
    directoryPathState: Observable<FoldersRouteData[]>;

    constructor(private folderService: FolderDirectoryService) {
        this.directoryPathState = this.getFoldersRouteState$();
    }

    private getFoldersRouteState$(): Observable<FoldersRouteData[]> {
        return combineLatest([this.folderService.pathTreeState$, this.folderService.activeDirectory$])
            .pipe(
                untilDestroyed(this),
                map(([route, activatedPath]) => route.map((item) => {
                    return {route: item, activatedPath: item.id === activatedPath.id}
                }))
            )
    }

    returnToDirectory(path: IFolderPath): void {
        this.folderService.returnToTargetDirPath(path);
    }

    ngOnInit(): void {
    }
}
